import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import styled from "@emotion/styled"
import {  mediaQueries } from "../components/breakpoints"
import { css } from "@emotion/react"
import { Container } from "../components/Container"
import Header from "../components/Header"
import { Section } from "../components/Section"
import { SRLWrapper } from "simple-react-lightbox";
import Img from "gatsby-image"
import moment from 'moment'

import iconHomepage from "../images/homepage.svg"
import iconFacebook from "../images/facebook.svg"
import iconTwitter from "../images/twitter.svg"
import iconLinkedin from "../images/linkedin.svg"
import { Modal } from "../components/Modal"
import Marked from "react-markdown"
import Button from "../components/Button"

const Grid = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-left: -1rem;
  margin-right: -1rem;
  ${mediaQueries.medium(
    css`
      margin: 0;
    `
  )}
  ${mediaQueries.large(
    css`
      grid-template-columns: 1fr 1fr 1fr 1fr;
    `
  )}
`

const ImageWrapper = styled("a")`
  position: relative;
  display: block;
  height: 250px;
  overflow: hidden;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  transform: scale(1);
  transition: all .2s ease-in-out;
  ${mediaQueries.large(
    css`
      height: 310px;
    `
  )}

  @media (hover: hover) {
    &:hover {
      z-index: 1;
      transform: scale(1.025);
      box-shadow: 0 0 1rem 1em rgba(0, 0, 0, 0.2);
    }
  }

  .gatsby-image-wrapper {
    object-fit: cover;
    min-width: 100%;
    min-height: 100%;
  }
`

const Speakers = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-left: -1rem;
  margin-right: -1rem;
  ${mediaQueries.medium(
    css`
      margin: 0;
    `
  )}
  ${mediaQueries.large(
    css`
      grid-template-columns: 1fr 1fr 1fr 1fr;
    `
  )}
`

const Speaker = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  &::before {
    content: "";
    display: table;
    padding-top: 100%;
  }
  ${mediaQueries.largeDown(
    css`
      &:nth-child(4n+1),
      &:nth-child(4n+4),
      &:nth-child(4n){
        background-color: #312E2E;
      }
    `
  )}
  ${mediaQueries.large(
    css`
      &:nth-child(8n+1),
      &:nth-child(8n+3),
      &:nth-child(8n+6),
      &:nth-child(8n){
        background-color: #312E2E;
      }
    `
  )}
`

const SpeakerContent = styled("div")`
  width: 100%;
  padding: 2rem;
  ${mediaQueries.smallDown(
    css`
      padding: 1.5rem 1rem;
    `
  )}
`

const SpeakerName = styled("h3")`
  color: var(--yellow);
  ${mediaQueries.mediumDown(
    css`
      font-size: 1.3rem;
    `
  )}
  ${mediaQueries.smallDown(
    css`
      font-size: 1.2rem;
    `
  )}
`

const SpeakerPosition = styled("h4")`
  font-weight: 400;
  ${mediaQueries.mediumDown(
    css`
      font-size: 1rem;
    `
  )}
`

const SpeakerIcons = styled("div")`
  margin-top: 1rem;
  &:empty {
    display: none;
  }
`

const SpeakerIconsModal = styled(SpeakerIcons)`
  margin-left: -.5rem;
`

const SpeakerIcon = styled("div")`
  display: inline-block;
  width: 2rem;
  text-align: center;

  a, button {
    width: 100%;
    display: inline-block;
    transform: scale(1);
    transition: all .1s ease-in-out;
    @media (hover: hover) {
      &:hover {
        transform: scale(1.15);
        filter: drop-shadow(0 0 2px var(--yellow));
      }
    }
  }
`

const Program = styled("div")`
  margin-left: -1rem;
  margin-right: -1rem;
  ${mediaQueries.medium(
    css`
      margin: 0;
    `
  )}
`

const ProgramHeader = styled("div")`
  position: sticky;
  top: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: 4rem 1fr 1fr;
  ${mediaQueries.medium(
    css`
      grid-template-columns: 14rem 1fr 1fr;
    `
  )}
`

const ProgramBody = styled("div")`
  display: grid;
  grid-template-columns: 4rem 1fr 1fr;
  ${mediaQueries.medium(
    css`
      grid-template-columns: 14rem 1fr 1fr;
    `
  )}
`

const ProgramDay = styled("div")`
  display: grid;
  grid-template-columns: 4rem 1fr 1fr;
  position: sticky;
  top: 0;
  z-index: 1;
  ${mediaQueries.medium(
    css`
      grid-template-columns: 14rem 1fr 1fr;
    `
  )}
`

const ProgramHeaderItem = styled("div")`
  padding: .75rem .5rem .5rem;
  text-align: center;
  background-color: var(--darkGray2);

  ${mediaQueries.medium(
    css`
      padding: .75rem 1rem .5rem;
    `
  )}

  ${mediaQueries.mediumDown(
    css`
      span {
        display: none;
      }
    `
  )}

  h2, p {
    margin-bottom: 0;
    ${mediaQueries.mediumDown(
      css`
        font-size: .875rem;
        line-height: 1.33;
      `
    )}
  }

  &:first-of-type {
    background-color: transparent;
    border-bottom-color: transparent;
  }

  &:last-of-type {
    border-left: 1px solid rgba(255, 255, 255, 0.08);
  }
`

const ProgramBodyItem = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: .75rem .5rem .5rem;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background-color: #312E2E;
  border-left: 1px solid rgba(255, 255, 255, 0.08);

  ${mediaQueries.medium(
    css`
      padding: .75rem 1rem .5rem;
    `
  )}

  h3, p {
    margin-bottom: 0;
    ${mediaQueries.mediumDown(
      css`
        font-size: .875rem;
        line-height: 1.33;
      `
    )}
  }

  h3 {
    font-size: 1rem;
    color: var(--yellow);
  }

  p:empty {
    display: none;
  }

  &:first-of-type {
    justify-content: center;
    flex-direction: row;
    text-align: center;
    flex-wrap: wrap;
    background-color: transparent;
    border-left: 0;
    ${mediaQueries.mediumDown(
      css`
        font-size: .875rem;
        span {
          line-height: .5;
          text-align: center;
          max-width: 100%;
          flex-basis: 100%;
        }
      `
    )}
  }
`

const ProgramBodyItemUnited = styled(ProgramBodyItem)`
  grid-column: span 2;
`

const ProgramDayItem = styled("div")`
  padding: .75rem .5rem .5rem;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background-color: #312E2E;
  border-left: 1px solid rgba(255, 255, 255, 0.08);

  ${mediaQueries.medium(
    css`
      padding: .75rem 1rem .5rem;
    `
  )}

  p {
    margin-bottom: 0;
    color: var(--yellow);
    ${mediaQueries.mediumDown(
      css`
        font-size: .875rem;
        line-height: 1.33;
      `
    )}
  }

  &:first-of-type {
    background-color: var(--darkGray2);
    border-left: 0;
  }
`

const ProgramDayItemUnited = styled(ProgramDayItem)`
  grid-column: span 2;
`

const Description = styled("div")`
  max-width: 47rem;
`

const Documents = styled("div")`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: var(--gutterWidth);
  grid-row-gap: var(--gutterWidth);
  ${mediaQueries.small(
    css`
       grid-template-columns: 1fr 1fr;
    `
  )}
  ${mediaQueries.large(
    css`
       grid-template-columns: 1fr 1fr 1fr;
    `
  )}
  h3 {
    font-size: var(--h4);
  }
`

const Document = styled("div")`

`

const DocumentParagraph = styled("p")`
  margin-bottom: 3rem;
  text-align: center;
`

const List = styled("ul")`
  list-style: none;
  margin: 0;
  padding: 0;
`


const ListItem = styled("li")`
  margin-bottom: .5rem;
`

const HeadingTheme = styled("h2")`
  span {
    text-transform: uppercase;
  }
`

const ProgramSimple = styled("div")`
  text-align: center;

  h3 {
    font-size: var(--h4);
    margin-bottom: .5em;
    color: var(--yellow);
  }

  h4 {
    font-size: var(--h5);
    margin-bottom: 2em;
    font-weight: 400;
    line-height: 1.5;
    strong {
      font-weight: 700;
    }
  }

  h4 + h4 {
    margin-top: -1.5em;
  }
`

const options = {
  caption: {
    showCaption: false,
  },
}

export default function Template({
  data,
}) {
  const { markdownRemark } = data
  const { frontmatter, html, excerpt } = markdownRemark
  return (
    <Layout
      title={frontmatter.title + " | Misesova akademie"}
      description="Již od roku 1996 pořádáme letní školu, kde se studenty debatujeme o ekonomice, politice, historii, filosofii anebo o čemkoliv, co se naskytne. Letní škola se jmenuje Misesova akademie Institutu liberálních studií, zkráceně MALI."
    >
      <Header />
      <Section>
        <Container jumbotron>
            <h1>Ročník {frontmatter.title} Misesovy akademie Institutu liberálních studií</h1>
            {((frontmatter.theme) && (
              <HeadingTheme>Téma: <span>{frontmatter.theme}</span></HeadingTheme>
            ))}
            <p>{moment(frontmatter.date).format(`D. M.`)} –⁠ {moment(frontmatter.dateEnd).format(`D. M. YYYY`)} - <a target="_blank" href={frontmatter.placeURL}>{frontmatter.placeName}</a></p>
            <Description
              dangerouslySetInnerHTML={{ __html: html }}
            />
        </Container>
      </Section>

      {frontmatter.speakers &&
      frontmatter.speakers.length ? (
        <Section>
          <Container >
            <h2>PŘEDNÁŠEJÍCÍ</h2>
            <Speakers>
              {frontmatter.speakers.map(speaker => (
                <Speaker>
                  <SpeakerContent key={speaker.id}>
                    {speaker.speakerName && (
                      <SpeakerName>{speaker.speakerName}</SpeakerName>
                    )}
                    {speaker.speakerPosition && (
                      <SpeakerPosition>{speaker.speakerPosition}</SpeakerPosition>
                    )}
                    <SpeakerIcons>
                      {speaker.speakerInfo && (
                        <SpeakerIcon>
                          <Modal>
                            <SpeakerName>{speaker.speakerName}</SpeakerName>
                            {speaker.speakerPosition && (
                              <SpeakerPosition>{speaker.speakerPosition}</SpeakerPosition>
                            )}
                            <SpeakerIconsModal>
                              {speaker.speakerHomepage && (
                                <SpeakerIcon>
                                  <a target="blank" rel="noopener noreferrer" href={speaker.speakerHomepage}>
                                    <img src={iconHomepage} />
                                  </a>
                                </SpeakerIcon>
                              )}
                              {speaker.speakerFacebook && (
                                <SpeakerIcon>
                                  <a target="blank" rel="noopener noreferrer" href={speaker.speakerFacebook}>
                                    <img src={iconFacebook} />
                                  </a>
                                </SpeakerIcon>
                              )}
                              {speaker.speakerTwitter && (
                                <SpeakerIcon>
                                  <a target="blank" rel="noopener noreferrer" href={speaker.speakerTwitter}>
                                    <img src={iconTwitter} />
                                  </a>
                                </SpeakerIcon>
                              )}
                              {speaker.speakerLinkedin && (
                                <SpeakerIcon>
                                  <a target="blank" rel="noopener noreferrer" href={speaker.speakerLinkedin}>
                                    <img src={iconLinkedin} />
                                  </a>
                                </SpeakerIcon>
                              )}
                            </SpeakerIconsModal>
                            <Marked source={speaker.speakerInfo} />
                          </Modal>
                        </SpeakerIcon>
                      )}
                      {speaker.speakerHomepage && (
                        <SpeakerIcon>
                          <a target="blank" rel="noopener noreferrer" href={speaker.speakerHomepage}>
                            <img src={iconHomepage} />
                          </a>
                        </SpeakerIcon>
                      )}
                      {speaker.speakerFacebook && (
                        <SpeakerIcon>
                          <a target="blank" rel="noopener noreferrer" href={speaker.speakerFacebook}>
                            <img src={iconFacebook} />
                          </a>
                        </SpeakerIcon>
                      )}
                      {speaker.speakerTwitter && (
                        <SpeakerIcon>
                          <a target="blank" rel="noopener noreferrer" href={speaker.speakerTwitter}>
                            <img src={iconTwitter} />
                          </a>
                        </SpeakerIcon>
                      )}
                      {speaker.speakerLinkedin && (
                        <SpeakerIcon>
                          <a target="blank" rel="noopener noreferrer" href={speaker.speakerLinkedin}>
                            <img src={iconLinkedin} />
                          </a>
                        </SpeakerIcon>
                      )}
                    </SpeakerIcons>
                  </SpeakerContent>
                </Speaker>
              ))}
            </Speakers>
          </Container>
        </Section>
      ) : null }


      {frontmatter.programActive === true && (
        <>
          {((frontmatter.programThursday) || (frontmatter.programFriday) || (frontmatter.programSaturday) || (frontmatter.programSunday)) && (
            <Section id="program">
              <Container>
                <h2>PROGRAM</h2>
                <Program>
                  <ProgramHeader>
                    <ProgramHeaderItem></ProgramHeaderItem>
                    <ProgramHeaderItem>
                      <p><strong>Misesova akademie <span>(MALI)</span></strong></p>
                    </ProgramHeaderItem>
                    <ProgramHeaderItem>
                      <p><strong>Misesův seminář <span>(MSLI)</span></strong></p>
                    </ProgramHeaderItem>
                  </ProgramHeader>

                  {frontmatter.programThursday &&
                  frontmatter.programThursday.length ? (
                    <>
                      <ProgramDay>
                        <ProgramDayItem>
                          <p><strong>Čtvrtek</strong></p>
                        </ProgramDayItem>
                        <ProgramDayItemUnited />
                      </ProgramDay>
                      {frontmatter.programThursday.map(program => (
                        <>
                          <ProgramBody key={program.id}>
                            <ProgramBodyItem>
                              {((program.programTimeStart) || (program.programTimeEnd)) && ((program.programTimeStart.lenght) || (program.programTimeEnd)) ? (
                                <>
                                  {moment(program.programTimeStart).local().format(`H:mm`)}<span>–</span>⁠{moment(program.programTimeEnd).local().format(`H:mm`)}
                                </>
                              ) : null }
                            </ProgramBodyItem>
                            {program.programUnited === false ? (
                               <>
                               <ProgramBodyItem>
                                 <h3>{program.programEvent1speaker}</h3>
                                 <p>{program.programEvent1topic}</p>
                               </ProgramBodyItem>
                               <ProgramBodyItem>
                                 <h3>{program.programEvent2speaker}</h3>
                                 <p>{program.programEvent2topic}</p>
                               </ProgramBodyItem>
                             </>
                            ) : (
                              <ProgramBodyItemUnited>
                                <h3>{program.programEvent1speaker}</h3>
                                <p>{program.programEvent1topic}</p>
                              </ProgramBodyItemUnited>
                            )}

                          </ProgramBody>
                        </>
                      ))}
                    </>
                  ) : null}

                  {frontmatter.programFriday &&
                  frontmatter.programFriday.length ? (
                    <>
                      <ProgramDay>
                        <ProgramDayItem>
                          <p><strong>Pátek</strong></p>
                        </ProgramDayItem>
                        <ProgramDayItemUnited />
                      </ProgramDay>
                      {frontmatter.programFriday.map(program => (
                        <>
                          <ProgramBody key={program.id}>
                            <ProgramBodyItem>
                              {((program.programTimeStart) || (program.programTimeEnd)) && ((program.programTimeStart.lenght) || (program.programTimeEnd)) ? (
                                <>
                                  {moment(program.programTimeStart).local().format(`H:mm`)}<span>–</span>⁠{moment(program.programTimeEnd).local().format(`H:mm`)}
                                </>
                              ) : null }
                            </ProgramBodyItem>
                            {program.programUnited === false ? (
                              <>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent1speaker}</h3>
                                  <p>{program.programEvent1topic}</p>
                                </ProgramBodyItem>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent2speaker}</h3>
                                  <p>{program.programEvent2topic}</p>
                                </ProgramBodyItem>
                              </>
                            ) : (
                              <ProgramBodyItemUnited>
                                <h3>{program.programEvent1speaker}</h3>
                                <p>{program.programEvent1topic}</p>
                              </ProgramBodyItemUnited>
                            )}
                          </ProgramBody>
                        </>
                      ))}
                    </>
                  ) : null}

                  {frontmatter.programSaturday &&
                  frontmatter.programSaturday.length ? (
                    <>
                      <ProgramDay>
                        <ProgramDayItem>
                          <p><strong>Sobota</strong></p>
                        </ProgramDayItem>
                        <ProgramDayItemUnited />
                      </ProgramDay>
                      {frontmatter.programSaturday.map(program => (
                        <>
                          <ProgramBody key={program.id}>
                            <ProgramBodyItem>
                              {((program.programTimeStart) || (program.programTimeEnd)) && ((program.programTimeStart.lenght) || (program.programTimeEnd)) ? (
                                <>
                                  {moment(program.programTimeStart).local().format(`H:mm`)}<span>–</span>⁠{moment(program.programTimeEnd).local().format(`H:mm`)}
                                </>
                              ) : null }
                            </ProgramBodyItem>
                            {program.programUnited === false ? (
                              <>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent1speaker}</h3>
                                  <p>{program.programEvent1topic}</p>
                                </ProgramBodyItem>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent2speaker}</h3>
                                  <p>{program.programEvent2topic}</p>
                                </ProgramBodyItem>
                              </>
                            ) : (
                              <ProgramBodyItemUnited>
                                <h3>{program.programEvent1speaker}</h3>
                                <p>{program.programEvent1topic}</p>
                              </ProgramBodyItemUnited>
                            )}

                          </ProgramBody>
                        </>
                      ))}
                    </>
                  ) : null}

                  {frontmatter.programSunday &&
                  frontmatter.programSunday.length ? (
                    <>
                      <ProgramDay>
                        <ProgramDayItem>
                          <p><strong>Neděle</strong></p>
                        </ProgramDayItem>
                        <ProgramDayItemUnited />
                      </ProgramDay>
                      {frontmatter.programSunday.map(program => (
                        <>
                          <ProgramBody key={program.id}>
                            <ProgramBodyItem>
                              {((program.programTimeStart) || (program.programTimeEnd)) && ((program.programTimeStart.lenght) || (program.programTimeEnd)) ? (
                                <>
                                  {moment(program.programTimeStart).local().format(`H:mm`)}<span>–</span>⁠{moment(program.programTimeEnd).local().format(`H:mm`)}
                                </>
                              ) : null }
                            </ProgramBodyItem>
                            {program.programUnited === false ? (
                              <>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent1speaker}</h3>
                                  <p>{program.programEvent1topic}</p>
                                </ProgramBodyItem>
                                <ProgramBodyItem>
                                  <h3>{program.programEvent2speaker}</h3>
                                  <p>{program.programEvent2topic}</p>
                                </ProgramBodyItem>
                              </>
                            ) : (
                              <ProgramBodyItemUnited>
                                <h3>{program.programEvent1speaker}</h3>
                                <p>{program.programEvent1topic}</p>
                              </ProgramBodyItemUnited>
                            )}
                          </ProgramBody>
                        </>
                      ))}
                    </>
                  ) : null }
                </Program>
              </Container>
            </Section>
          )}
        </>
      )}

      {frontmatter.programActive === false && (
        <>
          {frontmatter.programSimple &&
          frontmatter.programSimple.length ? (
            <Section id="program">
              <Container>
                <h2>PROGRAM</h2>
                <ProgramSimple>
                  <Marked source={frontmatter.programSimple} />
                </ProgramSimple>
              </Container>
            </Section>
          ) :  null }
        </>
      )}

      {frontmatter.program && (
        <Section>
          <Container narrow>
            <Button
              to={frontmatter.program.publicURL}
            >
              STÁHNOUT PROGRAM
            </Button>
          </Container>
        </Section>
      )}

      {frontmatter.documents &&
      frontmatter.documents.length ? (
        <Section>
          <Container >
            <h2>PODKLADY PRO MSLI</h2>
            <DocumentParagraph>Seznam textů k diskusi:</DocumentParagraph>
            <Documents>
              {frontmatter.documents.map(document => (
                <Document key={document.id}>
                  {document.documentSpeaker && (
                    <>
                    <h3>{document.documentSpeaker}</h3>
                    <List>
                      {document.documentItems.map(documentItem => (
                        <ListItem>
                          <a target="_blank" rel="noopener noreferrer" href={documentItem.documentLink}>{documentItem.documentName}</a> {documentItem.documentAuthor && (
                            <>
                              <br/>
                              ({documentItem.documentAuthor})
                            </>
                          )}
                        </ListItem>
                      ))}
                    </List>
                    </>
                  )}

                </Document>
              ))}
            </Documents>
          </Container>
        </Section>
      ) : null }

      {frontmatter.images &&
      frontmatter.images.length ? (
        <Section last>
          <Container>
            <h2>Galerie</h2>
            <SRLWrapper options={options}>
              <Grid>
                {frontmatter.images.map(image => (
                  <div key={image.image.id}>
                    <ImageWrapper data-attribute="SRL" href={image.image.childImageSharp.fluid.src}>
                      <Img
                        data-attribute="SRL"
                        fluid={image.image.childImageSharp.fluid}
                        alt={image.alt}
                        max-width="400"
                      />
                    </ImageWrapper>
                  </div>
                ))}
              </Grid>
            </SRLWrapper>
          </Container>
        </Section>
      ) : null}
    </Layout>
  )
}

export const postQuery = graphql`
  query($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt
      frontmatter {
        date
        dateEnd
        title
        templateKey
        description
        placeName
        placeURL
        theme
        program {
          publicURL
        }
        speakers {
          speakerName
          speakerPosition
          speakerInfo
          speakerHomepage
          speakerFacebook
          speakerTwitter
          speakerLinkedin
        }
        programActive
        programSimple
        programThursday {
          programTimeStart
          programTimeEnd
          programEvent1speaker
          programEvent1topic
          programEvent2speaker
          programEvent2topic
          programUnited
        }
        programFriday {
          programTimeStart
          programTimeEnd
          programEvent1speaker
          programEvent1topic
          programEvent2speaker
          programEvent2topic
          programUnited
        }
        programSaturday {
          programTimeStart
          programTimeEnd
          programEvent1speaker
          programEvent1topic
          programEvent2speaker
          programEvent2topic
          programUnited
        }
        programSunday {
          programTimeStart
          programTimeEnd
          programEvent1speaker
          programEvent1topic
          programEvent2speaker
          programEvent2topic
          programUnited
        }
        documents {
          documentSpeaker
          documentItems {
            documentName
            documentLink
            documentAuthor
          }
        }
        images {
          image {
            id
            publicURL
            childImageSharp {
              fluid(quality: 95, maxWidth: 1200) {
                ...GatsbyImageSharpFluid_withWebp
                src
              }
            }
          }
          alt
        }
      }
    }
  }
`;
